<header>
  <div class="icon">
    <mat-icon class="icon__content">verified_user</mat-icon>
  </div>

  <h1 *ngIf="!data.isAuthenticatorAppRegistered" class="heading">Authenticator App Setup</h1>
  <h1 *ngIf="data.isAuthenticatorAppRegistered" class="heading">2-Factor Verification</h1>
</header>

<section *ngIf="data.isAuthenticatorAppRegistered">
  <p>
    To keep your account safe, we want to make sure it's really you.
    <br />Your 6-digit code can be found in your Authenticator app.
  </p>
</section>

<section *ngIf="!data.isAuthenticatorAppRegistered">
  <p>
    To keep your account safe, we want to make sure it's really you.
    <br />Follow these steps to verify your account:
  </p>

  <ol>
    <li class="step">
      Search for an Authenticator app (e.g. Microsoft, Google, or equivalent) in
      Google Play or App Store and install it on your mobile device.
    </li>
    <li class="step">
      Scan the QR code below with the Authenticator app (or copy and paste it
      into the app if you are currently on mobile device).
    </li>
    <li class="step">
      Enter the 6-digit verification code in the Authenticator app.
    </li>
  </ol>

  <qrcode
    [qrdata]="data.mfaTotpUri"
    [width]="150"
    [imageSrc]="'../../../../../assets/logos/idea_rhino.png'"
    [imageHeight]="42"
    [imageWidth]="42"
    [errorCorrectionLevel]="'M'"
  ></qrcode>

  <div>
    <p>
      {{ data.mfaTotpSecret }}
      <button
        mat-icon-button
        type="button"
        (click)="copy()"
        class="small-icon-button"
      >
        <mat-icon>content_copy</mat-icon>
      </button>
    </p>
  </div>
</section>

<section>
  <form [formGroup]="form">
    <div class="code">
      <mat-form-field appearance="outline" class="code__field">
        <mat-label>Enter 6-digit verification code</mat-label>
        <input
          matInput
          formControlName="code"
          type="text"
          placeholder="Enter 6-digit verification code"
          [mask]="codeMask"
          inputmode="numeric"
        />
        <mat-error
          *ngIf="
            form.get('code').errors
              | hasControlError : ['mfa_code_invalid'] : ConditionOperator.Only
          "
        >
          Wrong code. Try again.
        </mat-error>
        <mat-error
          *ngIf="
            form.get('code').errors | hasControlError : ['required', 'mask']
          "
        >
          Verification code must contain {{ codeMask?.length }} digits.
        </mat-error>
      </mat-form-field>
    </div>
    <div
      class="trust-device"
      *ngIf="data.config.isTrustingDeviceAllowed && data.isAuthenticatorAppRegistered"
    >
      <mat-checkbox color="primary" formControlName="trustDevice">
        <span class="trust-device__label">
          Remember this device for 30 days. Do not check box if on a public
          device.
        </span>
      </mat-checkbox>
    </div>
  </form>

  <footer class="footer">
    <div class="actions">
      <button
        mat-flat-button
        color="primary"
        class="actions__verify"
        (click)="onClickVerify()"
      >
        VERIFY
      </button>
    </div>
    <p class="info">
      Having trouble? Contact your Business Advisor or Admin for assistance.
    </p>
  </footer>
</section>
